import { render, staticRenderFns } from "./CustomerTranslationEditPopup.vue?vue&type=template&id=71d29e3e&"
import script from "./CustomerTranslationEditPopup.vue?vue&type=script&lang=js&"
export * from "./CustomerTranslationEditPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports